{
  "OPEN" : "#EFF0F6",
  "EXPIRED" : "#FFE6B0",
  "COMPLETE" : "#CBFFAE",
  "RETRACTED" : "#FFABE8"
}
